import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {CharCounterTextareaComponent} from './char-counter-textarea.component';
import { ReactiveFormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    CharCounterTextareaComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule
  ],
  exports: [
    CharCounterTextareaComponent
  ]
})
export class CharCounterTextareaModule { }
